import { configureStore } from '@reduxjs/toolkit';
import communityReducer from './slices/communitySlice';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import marketplaceReducer from './slices/marketplaceSlice';
import teachersReducer from './slices/teachersSlice';

/**
 * Redux Store
 *
 * Slices:
 *  - auth        → Login, Register, User Profile     (api/auth.js)
 *  - community   → Communities, Categories           (api/communities.js)
 *  - marketplace → Courses, Recommended, Trending    (api/marketplace.js)
 *  - teachers    → Teacher Listing, Teacher Detail   (api/teachers.js)
 *  - ui          → Sidebar, Theme, Notifications, Toast
 */
const store = configureStore({
  reducer: {
    auth: authReducer,
    community: communityReducer,
    marketplace: marketplaceReducer,
    teachers: teachersReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
